<svg width="100%" height="100%" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
	<g id="plus-large_svgrepo.com">
		<path
			id="Vector"
			d="M2.66699 7.99996H13.3337M8.00033 2.66663V13.3333"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</g>
</svg>
